<div class="reports-header">
  <div class="reports-headline">
    <img class="venue-icon" alt="venue-placeholder"
      [src]="venueDetails?.pictureUrl ? venueDetails?.pictureUrl : './assets/images/icons/venue-logo-placeholder-01.svg'">
    <div class="reports-entity">
      <span><b>{{venueDetails.name}}</b></span><span><i>, {{'REPORTS.REPORTS' | translate | lowercase}}</i></span>
    </div>
  </div>
  <div class="excel-btn-wrapper">
    <button class="excel-btn">{{'REPORTS.EXCEL' | translate }}</button>
  </div>
</div>
<div class="reports-wrapper">
<div class="weekly-reservations">
    <div class="d-flex flex-row justify-content-between py-2">
      <p-dropdown class="weekly-res-dropdown" [(ngModel)]="weeklyResWeekFormat" (ngModelChange)="displayWeeklyReservations()" [options]="weeklyResWeekFormatOptions"
                  placeholder="Week set" [showClear]="false" optionLabel="label">
      </p-dropdown>
      <p-dropdown class='download-report-button' [(ngModel)]="weeklyResReportChoice" (ngModelChange)="downloadOrSendWeeklyReservationsReport()" [options]="reportFileOptions"
                  placeholder="_" [showClear]="false" optionLabel="label">
      </p-dropdown>
    </div>
    <p-chart type="line" [data]="dataChartWeeklyReservations" [options]="optionsChartWeeklyReservations"></p-chart>
    <div class="weekly-reservations-headline">{{ 'REPORTS.WEEKLY_RESERVATIONS' | translate}}
    </div>
</div>

<div class="total-reservations">
    <div class="d-flex flex-row justify-content-between py-2">
      <p-calendar class="date-range-reports" dateFormat="d M y" [(ngModel)]="reservationsStatisticsDates" (ngModelChange)="getReservationsStatistics()" selectionMode="range"
                  [readonlyInput]="true" placeholder="{{ 'REPORTS.DATE_RANGE' | translate}}" [showIcon]="true">
      </p-calendar>
      <p-dropdown class='download-report-button' [(ngModel)]="totalResReportChoice" (ngModelChange)="downloadOrSendTotalReservationsReport()" [options]="reportFileOptions"
                  placeholder="_" [showClear]="false" optionLabel="label">
      </p-dropdown>
    </div>
    <div>
      <div class="total-reservations-headline">{{ 'REPORTS.TOTAL_RESERVATIONS' | translate}}</div>
      <div class="total-reservations-amount">{{reservationsStatistics.totalReservations}}</div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="upcoming-past-reservations">{{ 'REPORTS.UPCOMING' | translate}}</div>
        <div class="upcoming-past-reservations">{{reservationsStatistics.upcomingReservations}}</div>
      </div>
      <div class="col-6">
        <div class="upcoming-past-reservations">{{ 'REPORTS.PAST' | translate}}</div>
        <div class="upcoming-past-reservations">{{reservationsStatistics.pastReservations}}</div>
      </div>
    </div>
</div>

<div class="most-visited-events">
  <div class="d-flex flex-row justify-content-between py-2">
    <p-calendar class="date-range-reports" dateFormat="d M y" [(ngModel)]="mostVisitedEventsDates" (ngModelChange)="getMostVisitedEvents()" selectionMode="range"
                placeholder="{{ 'REPORTS.DATE_RANGE' | translate}}" [readonlyInput]="true" [showIcon]="true">
    </p-calendar>
    <p-dropdown class='download-report-button' [(ngModel)]="mostVisitedEventsReportChoice" (ngModelChange)="downloadOrSendMostVisitedEventsReport()" [options]="reportFileOptions"
                placeholder="_" [showClear]="false" optionLabel="label">
    </p-dropdown>
  </div>
  <div class="most-visited-headline">{{ 'REPORTS.MOST_VISITED_EVENTS' | translate}}</div>
  <div class="d-flex flex-row justify-content-between">
    <div class="most-visited-info">{{ 'REPORTS.LIST_EVENTS' | translate}}</div>
    <div class="most-visited-info">{{mostVisitedEvents.length}} {{ 'REPORTS.EVENTS' | translate | lowercase}}</div>
  </div>
  <div *ngIf="dataChartMostVisitedEvents?.datasets[0].data.length > 0" class="most-visited-events-wrapper">
    <p-chart type="bar" [data]="dataChartMostVisitedEvents" [options]="mostVisitedEventsOptions"></p-chart>
  </div>
</div>

<div class="upcoming-events">
  <div class="d-flex flex-row justify-content-between py-2">
    <p-calendar class="date-range-reports" dateFormat="d M y" [(ngModel)]="upcomingEventsStatisticsDates" [minDate]="minDateUpcomingEventsStatistics" (ngModelChange)="getUpcomingEventReservationStatistics()" selectionMode="range"
                [readonlyInput]="true" placeholder="{{ 'REPORTS.DATE_RANGE' | translate}}" [showIcon]="true">
    </p-calendar>
    <p-dropdown class='download-report-button' [(ngModel)]="upcomingEventsStatisticsReportChoice" (ngModelChange)="downloadOrSendUpcomingEventReservationStatistics()" [options]="reportFileOptions"
                placeholder="_" [showClear]="false" optionLabel="label">
    </p-dropdown>
  </div>
  <div class="headline">{{ 'REPORTS.UPCOMING_EVENTS' | translate}}</div>
  <div class="d-flex flex-row justify-content-between">
    <div class="info-category">{{ 'REPORTS.LIST_EVENTS' | translate}}</div>
    <div class="info-category">{{upcomingEventsStatistics.length}} {{ 'REPORTS.EVENTS' | translate | lowercase}}</div>
  </div>
  <div *ngIf="dataChartUpcomingEventsStatistics?.datasets[0].data.length > 0" class="upcoming-events-wrapper">
    <p-chart type="bar" [data]="dataChartUpcomingEventsStatistics" [options]="upcomingEventsStatisticsOptions" ></p-chart>
  </div>
</div>

<div class="reservations-details">
  <div class="headline">{{ 'REPORTS.RESERVATION_DETAILS' | translate}}</div>
  <p-tabView>
    <p-tabPanel header="{{'REPORTS.PAST_RESERVATIONS' | translate}}">
      <div class="d-flex flex-row justify-content-between">
        <div>
          <span class="event-text" style="marginRight: 10px;">{{'REPORTS.EVENT' | translate }}</span>
          <p-dropdown class="choose-events-dropdown" [(ngModel)]="showPastEventReservations" (ngModelChange)="getPastReservationsDetails()" [options]="pastEvents"
                      placeholder="Choose event" [showClear]="false" optionLabel="nameAndDate">
          </p-dropdown>
        </div>
        <p-dropdown class='download-report-button' [(ngModel)]="pastEventsReservationsReportChoice" (ngModelChange)="downloadOrSendPastEventReservations()" [options]="reportFileOptions"
                    placeholder="_" [showClear]="false" optionLabel="label">
        </p-dropdown>
      </div>
     <p-table [scrollable]="true" scrollHeight="350px" [value]="pastReservationDetails">
       <ng-template pTemplate="header">
         <tr>
           <th>{{ 'REPORTS.PAST_RESERVATIONS_NAME' | translate}}</th>
           <th>{{ 'REPORTS.PAST_RESERVATIONS_PEOPLE' | translate}}</th>
           <th>{{ 'REPORTS.PAST_RESERVATIONS_ALL_VISITS' | translate}}</th>
           <th>{{ 'REPORTS.PAST_RESERVATIONS_PREVIOUS_PRESENCE' | translate}}</th>
         </tr>
       </ng-template>
       <ng-template pTemplate="body" let-reservation>
         <tr>
           <td>{{ reservation.name }}</td>
           <td>{{ reservation.people }}</td>
           <td>{{ reservation.allVisits}}</td>
           <td>{{ reservation.previousPresence }}</td>
         </tr>
       </ng-template>
     </p-table>
    </p-tabPanel>
    <p-tabPanel header="{{'REPORTS.UPCOMING_RESERVATIONS' | translate}}">
      <div class="d-flex flex-row justify-content-between">
        <div>
          <span class="event-text" style="marginRight: 10px;">{{'REPORTS.EVENT' | translate }}</span>
          <p-dropdown class="choose-events-dropdown" [(ngModel)]="showUpcomingEventReservations" (ngModelChange)="getUpcomingReservationsDetails()" [options]="upcomingEvents"
                      placeholder="Choose event" [showClear]="false" optionLabel="nameAndDate">
          </p-dropdown>
        </div>
        <p-dropdown class='download-report-button' [(ngModel)]="upcomingEventsReservationsReportChoice" (ngModelChange)="downloadOrSendUpcomingEventReservations()" [options]="reportFileOptions"
                    placeholder="_" [showClear]="false" optionLabel="label">
        </p-dropdown>
      </div>
      <p-table [scrollable]="true" scrollHeight="350px" [value]="upcomingReservationDetails">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'REPORTS.UPCOMING_RESERVATIONS_NAME' | translate}}</th>
            <th>{{ 'REPORTS.UPCOMING_RESERVATIONS_PEOPLE' | translate}}</th>
            <th>{{ 'REPORTS.UPCOMING_RESERVATIONS_LAST_VISIT' | translate}}</th>
            <th>{{ 'REPORTS.UPCOMING_RESERVATIONS_ALL_VISITS' | translate}}</th>
            <th>{{ 'REPORTS.UPCOMING_RESERVATIONS_STATUS' | translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-reservation>
          <tr>
            <td>{{ reservation.name }}</td>
            <td>{{ reservation.people }}</td>
            <td>{{ reservation.lastReservations }}</td>
            <td>{{ reservation.allVisitsCount }}</td>
            <td>{{ reservationStatus[reservation.status] }}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
  </p-tabView>
</div>
</div>
